import OrderChangeTaxiRequest from "../../../api/raily/order/change-taxi/order-change-taxi.request";
import OrderChangeTaxiParams from "./order-change-taxi-params";

const create = (params: OrderChangeTaxiParams): OrderChangeTaxiRequest => {
  return {
    orderUuid: params.orderUuid,
    newTargetTaxiId: params.newTargetTaxiId,
  };
};

const orderChangeTaxiParamsFactory = {
  create,
};

export default orderChangeTaxiParamsFactory;
